module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "map-container"
  }, [_c('gmap-map', {
    ref: "map",
    class: {
      map: true, loaded: _vm.mapLoaded
    },
    attrs: {
      "center": {
        lat: 0,
        lng: 0
      },
      "streetViewControl": false,
      "options": {
        streetViewControl: false,
        mapTypeControl: false,
        draggable: this.draggable != null ? this.draggable : true
      },
      "zoom": 1,
      "mapTypeControl": false
    },
    on: {
      "maptypeid_changed": _vm.handleMapTypeIdChange,
      "click": _vm.handleMapClick,
      "rightclick": function($event) {
        _vm.$emit('rightclick')
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-882423ca","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/scenes/Dashboard/components/NadeMap/index.vue
// module id = 722
// module chunks = 1